import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/imprimirInformeExtracciones`, method: 'POST', body: list, token: token})
}